import { render, staticRenderFns } from "./BusinessDocumentReturnForm.vue?vue&type=template&id=25a41079&"
import script from "./BusinessDocumentReturnForm.vue?vue&type=script&lang=js&"
export * from "./BusinessDocumentReturnForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25a41079')) {
      api.createRecord('25a41079', component.options)
    } else {
      api.reload('25a41079', component.options)
    }
    module.hot.accept("./BusinessDocumentReturnForm.vue?vue&type=template&id=25a41079&", function () {
      api.rerender('25a41079', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/businessDocumentDetailPages/BusinessDocumentReturnForm.vue"
export default component.exports